import PropTypes from "prop-types";

import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { formatNumber } from "@/features/shared";

const UsageLimitsSection = ({ promotion }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Batas Penggunaan
      </Typography>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Batas Penggunaan Global
          </Typography>
          <Typography variant="body1">
            {formatNumber(promotion.globalUsageLimit)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Batas Per Pelanggan
          </Typography>
          <Typography variant="body1">
            {promotion.perCustomerLimit != null
              ? formatNumber(promotion.perCustomerLimit)
              : "-"}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

UsageLimitsSection.propTypes = {
  promotion: PropTypes.object.isRequired,
};

export default UsageLimitsSection;
